import { render, staticRenderFns } from "./spiaggia_annulla.vue?vue&type=template&id=b4dff408&"
import script from "./spiaggia_annulla.vue?vue&type=script&lang=js&"
export * from "./spiaggia_annulla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports